export default __webpack_public_path__ + "media/images/features/local_delivery/episode3/LP_03-77c133292c9c4d9ca32a2d6cfd484566.jpg";